module.exports = __webpack_public_path__ + "static/media/03-move-detail.fa9038de.png";